// extracted by mini-css-extract-plugin
export default {"bg":"Home_bg__yWvTR","title":"Home_title__B665W"};